import { render, staticRenderFns } from "./MainNombre.vue?vue&type=template&id=cf3ee51a"
import script from "./MainNombre.vue?vue&type=script&lang=js"
export * from "./MainNombre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports